<template>
  <v-form
    ref="form"
    @submit.prevent="submit"
    @keypress.13.stop
    :class="$style.searchSelect"
  >
    <TextField
      v-model.trim="search"
      v-bind="$attrs"
      v-on="$listeners"
      :dense="dense"
      blue_icon
      :label="label"
      :background-color="background_color"
      :loading="loading"
      prepend-inner-icon="mdi-magnify"
      hide-details
      clearable
      @keyup.esc="clear_search"
      @keyup.space="submit"
      @click:clear="clear_search"
      @click:prepend-inner="submit"
      @blur="handle_blur"
      require
      :height="56"
      centered
      :disabled="disabled"
      :rules="[(v) => is_require(v) || require_message]"
    />
  </v-form>
</template>

<script lang="ts">
import {
  Component, Prop, Mixins, Watch,
} from 'vue-property-decorator';
import { TextField } from '@/components/global/inputs/text-field/';
import ValidateMixin from '@/mixins/validate';
import { repairs_store } from '@/store';

const { state, mutations } = repairs_store.modules.new_repair;

@Component({
  components: {
    TextField,
  },
})
export default class SearchSelectBlock extends Mixins(ValidateMixin) {
  @Prop({ type: String, default: 'Поиск' })
  label!: string;

  @Prop({ type: String, default: '#fff' })
  background_color!: string;

  @Prop({ type: Boolean, default: false })
  dense!: boolean;

  @Prop({ type: Boolean, default: false })
  loading!: boolean;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ type: String, default: '', required: false })
  passed_search!: string;

  @Watch('passed_search')
  on_set_search_change() {
    if (this.passed_search) this.search = this.passed_search;
  }

  @Watch('search')
  clear_field(old_value: string, new_value: string) {
    if (old_value !== new_value) {
      mutations.TOGGLES_IS_SUBMITTED(false);
    }
  }

  search = '';

  get is_submitted() {
    return state.is_submitted;
  }

  clear_search() {
    this.search = '';
    this.$emit('clear', '');
  }

  handle_blur() {
    if (!this.is_submitted) {
      this.submit();
    }
  }

  submit() {
    if (this.search) {
      this.$emit('submit', this.search);
      mutations.TOGGLES_IS_SUBMITTED(true);
    }
  }
}
</script>

<style module lang="scss">
.searchSelect {
  :global(.v-text-field--outlined .v-label--active) {
    transform: translateY(-24px) scale(0.75) !important;
}
}
</style>
